import React from "react";
import { MdMenuBook, MdCalculate, MdDirectionsRun } from "react-icons/md";
const RowItem = ({ icon: Icon, label, color }) => (
    <div className="flex items-center gap-3 mb-4">
        <Icon className="text-2xl text-[#808080]" size={40} />
        <div className="w-full">
            <p className="text-sm font-medium">{label}</p>
            <div className={`h-10 mt-2`} style={{ backgroundColor: color }}></div>
        </div>
    </div>
);

const LegendItem = ({ color, label }) => (
    <div className="flex items-center gap-2 mb-7">
        <div className="w-5 h-5" style={{ backgroundColor: color }}></div>
        <span className="text-md font-medium ml-3">{label}</span>
    </div>
);
const GeneratePdf = () => {
    return (
        <div className="flex justify-center">
            <div className="p-14 max-w-lg bg-white rounded-md font-sans w-full">
                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <h1 className="font-extrabold text-2xl">1st level of analysis</h1>
                </div>

                {/* Part A */}
                <div className="mb-8">
                    <h1 className="font-extrabold text-2xl mb-4">Part A</h1>
                    <RowItem icon={MdMenuBook} label="Reading, Writing & Comprehension" color="#F47878" />
                    <RowItem icon={MdCalculate} label="Math (M)" color="#AFDC71" />
                    <RowItem icon={MdDirectionsRun} label="Motor Skills (MS)" color="#AFDC71" />
                </div>

                {/* Part B */}
                <div>
                    <h3 className="font-extrabold text-2xl mb-4">Part B</h3>
                    <RowItem icon={MdMenuBook} label="Active Working Memory (AWM)" color="#AFDC71" />
                    <RowItem icon={MdCalculate} label="Soft Skills (SS)" color="#FFE683" />
                    <RowItem icon={MdDirectionsRun} label="Impulse Control (IC)" color="#AFDC71" />
                    <RowItem icon={MdMenuBook} label="Perspective Shifting (PS)" color="#F47878" />
                    <RowItem icon={MdMenuBook} label="Emotional Control (EC)" color="#AFDC71" />
                    <RowItem icon={MdMenuBook} label="Planning + Organization (P+O)" color="#AFDC71" />
                    <RowItem icon={MdMenuBook} label="Initiation (I)" color="#F47878" />
                    <RowItem icon={MdMenuBook} label="Self Monitoring (SM)" color="#AFDC71" />
                    <RowItem icon={MdMenuBook} label="Attention & Distractibility (A+D)" color="#AFDC71" />
                    <RowItem icon={MdMenuBook} label="Prioritization (P)" color="#F47878" />
                </div>

                {/* Legend */}
                <div className="w-full mt-10 border-b-2 border-[#CECECE]">
                    <div className="mb-10">
                        <LegendItem color="#F47878" label="Significant Concerns" />
                        <LegendItem color="#F4E07D" label="Mild concerns" />
                        <LegendItem color="#AFDC71" label="No concerns" />
                    </div>
                </div>

                {/* 2nd Level of Analysis Header */}
                <div className="flex justify-between items-center mb-6">
                    <h1 className="font-extrabold text-2xl mt-4">2nd level of analysis</h1>
                </div>

                {/* Donut Chart */}
                <div className="flex justify-center items-center p-2">
                    <div className="bg-white rounded-xl max-w-2xl">
                        {/* SVG Pie Chart */}
                        <div className="flex justify-center mb-8">
                            <svg width="450" height="450" viewBox="0 0 280 280" className="drop-shadow-md">
                                {/* Social-emotional skills section */}
                                <path d="M 140 140 L 140 40 A 100 100 0 0 1 226.6 90 Z" fill="#8BC34A" />

                                {/* Academic skills section */}
                                <path d="M 140 140 L 226.6 90 A 100 100 0 0 1 226.6 190 Z" fill="#CDDC39" />

                                {/* Daily life skills section */}
                                <path d="M 140 140 L 226.6 190 A 100 100 0 1 1 140 40 Z" fill="#689F38" />

                                {/* Text Labels with smaller size and bolder weight */}
                                <text x="170" y="90" fill="white" fontWeight="900" fontSize="10" textAnchor="middle">
                                    <tspan x="182" dy="">Social-emotional</tspan>
                                    <tspan x="182" dy="16">skills</tspan>
                                </text>
                                <text x="205" y="140" fill="white" fontWeight="900" fontSize="10" textAnchor="middle">
                                    <tspan x="200" dy="0">Academic skills</tspan>
                                </text>
                                <text x="110" y="120" fill="white" fontWeight="900" fontSize="10" textAnchor="middle">
                                    <tspan x="90" dy="14">Daily life skills</tspan>
                                </text>
                            </svg>

                        </div>
                        {/* Strength Legend */}
                        <div className="mt-5 mb-15">
                            <LegendItem color="#7BA800" label="highest strength" />
                            <LegendItem color="#A2C72D" label="medium strength" />
                            <LegendItem color="#D4EC7C" label="lowest strength" />
                        </div>
                        <div className="mt-10 w-[400px] border-b-2 border-[#CECECE]">

                        </div>
                    </div>
                </div>
                <div>

                </div>

            </div>
        </div>
    );
};

export default GeneratePdf;
